import { isDefined } from '../../util/functions.js';
import { getPreparationExpiry } from '../../util/stability-expiry.js';
// Production time of a sequence, as on the label: the newest COMPLETE_PRODUCTION (logs ordered newest first).
export function findProducedAt(logs) {
    return logs.find(log => log.details?.action === 'COMPLETE_PRODUCTION')?.performedAt ?? null;
}
// Batches and source returns that bound a returned preparation, selected as the label does.
export function getReturnExpirySources(sequence) {
    const item = sequence.order?.distributedOrders?.orders?.find(order => order.sequenceId === sequence.id);
    return {
        drugBatchIds: [
            ...(item?.activeSubstances?.batches?.map(b => b.batchId) ?? []),
            ...(item?.restVials?.map(rv => rv.batchId).filter(isDefined) ?? []),
        ],
        carrierBatchIds: item?.carrier?.batches?.map(b => b.batchId) ?? [],
        returnExpiries: (item?.returns ?? []).flatMap(ret => (ret.expiryDate ? [new Date(ret.expiryDate).getTime()] : [])),
    };
}
// A return can't be used from its use-by on; without a use-by it never expires (CY-328).
export function isReturnExpired(expiryDate, now) {
    if (expiryDate == null)
        return false;
    return new Date(expiryDate).getTime() <= now;
}
// Use-by of a returned preparation: the stability window runs from production, never from the return (CY-328).
export function getReturnExpiry(input) {
    const { producedAt, returnedAt, ...expiryInput } = input;
    // without a production time the window can't be placed, so the return counts as expired
    if (producedAt === null)
        return returnedAt;
    return getPreparationExpiry({ ...expiryInput, referenceTime: producedAt });
}
//# sourceMappingURL=return-expiry.js.map